import React from 'react';
import './NotFound.css';

const navigateTo = (path: string): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

const NotFound = () => {
  return (
    <section className="feature-not-found" role="status" aria-live="polite">
      <div className="feature-not-found-card">
        <div className="feature-not-found-logo">Z<span className="brand-q">o</span>pe<span className="brand-q">o</span></div>
        <p className="feature-not-found-code">404 — Page not found</p>
        <h1>The page you’re looking for doesn’t exist or has been moved.</h1>
        <div className="feature-not-found-actions">
          <button type="button" className="btn primary" onClick={() => navigateTo('/store')}>
            Go to Dashboard
          </button>
          <button type="button" className="btn ghost" onClick={() => navigateTo('/')}>
            Go Home
          </button>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
